import React from 'react';
import { cn } from '../poker-ui/utils/cn';

/**
 * @param {number} exactLossSeka chips + currentBet за местом (как серверный leaverDebit при аборте).
 */
export function OnlineSekaLeaveModal({
  open,
  onClose,
  onConfirm,
  exactLossSeka,
  heroChips,
  heroStreetBet,
  sessionStartStack,
}) {
  if (!open) return null;

  const start = Math.max(0, Math.floor(Number(sessionStartStack) || 0));
  const chips = Math.max(0, Math.floor(Number(heroChips) || 0));
  const street = Math.max(0, Math.floor(Number(heroStreetBet) || 0));
  const exposure = Math.max(0, Math.floor(Number(exactLossSeka) || 0));
  const fmt = (n) => n.toLocaleString('ru-RU');

  const rawDelta = chips - start;
  const deltaLabel = `${rawDelta > 0 ? '+' : ''}${rawDelta.toLocaleString('ru-RU')}`;
  const deltaTone =
    rawDelta > 0 ? 'text-emerald-400' : rawDelta < 0 ? 'text-red-400' : 'text-zinc-200';

  const ratTail =
    street > 0
      ? <> Расклад: {fmt(chips)} во фишках + {fmt(street)} уже в торге.</>
      : <> Всё это во фишках за столом.</>;

  return (
    <div
      className="fixed inset-0 z-[72] overflow-y-auto overscroll-contain bg-black/70"
      role="dialog"
      aria-modal="true"
      aria-labelledby="leave-online-seka-title"
      onClick={onClose}
    >
      <div
        className="relative flex min-h-[100dvh] w-full items-center justify-center p-3 py-3 sm:p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={cn(
            'w-full max-w-[min(92vw,340px)] rounded-2xl border-2 border-orange-500/50',
            'bg-[#12100e] px-4 py-4 shadow-[0_12px_40px_rgba(0,0,0,0.65)] sm:px-5 sm:py-5'
          )}
        >
          <h2
            id="leave-online-seka-title"
            className="text-center text-base font-black uppercase tracking-wide text-orange-200 sm:text-lg"
          >
            Уже бежим?
          </h2>
          <p className="mt-3 text-center text-sm leading-snug text-zinc-200">
            С корабля прыгают только крысы — не обессудь. Распилим ровно{' '}
            <span className="font-mono font-black text-amber-200">{fmt(exposure)}</span> SEKA.
            {ratTail}
          </p>
          <p className="mt-4 text-center text-lg font-black tabular-nums text-amber-200 sm:text-xl">
            {fmt(exposure)}{' '}
            <span className="text-sm font-bold uppercase tracking-wide text-amber-400/90">SEKA</span>
            {start > 0 ? (
              <span className="mt-1 block text-xs font-semibold text-zinc-400">
                только фишки к входу{' '}
                <span className={cn('font-mono font-bold', deltaTone)}>{deltaLabel} SEKA</span>
              </span>
            ) : null}
          </p>
          <div className="mt-5 grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-11 items-center justify-center rounded-lg border border-zinc-500/80 bg-zinc-800 text-xs font-bold text-zinc-100 transition hover:bg-zinc-700"
            >
              Остаюсь
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="inline-flex h-11 items-center justify-center rounded-lg border border-orange-500/80 bg-orange-800 text-xs font-black text-white transition hover:bg-orange-700"
            >
              Бегу
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
